var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterfaceGlyphComment = function SvgInterfaceGlyphComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3c-1.1 0-1.99.9-1.99 2l-.008 11.998c0 1.105.895 2.002 2 2.002H6v4l4-4h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 2h16v12H4.002z"
  })));
};
export default SvgInterfaceGlyphComment;